import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { ArcadiaGreenButtonConnectionDto } from "../dto/arcadia-green-button.dto"
import { arcadiaGreenButtonService } from "../services/arcadia-green-button.service"

type SelectArcadiaGreenButtonMeterParams = {
  connectionId: string
  meterId: string
  proposalId: string
  siteId: string
}

export const useSelectArcadiaGreenButtonMeter = (): UseMutationResult<
  ArcadiaGreenButtonConnectionDto,
  unknown,
  SelectArcadiaGreenButtonMeterParams,
  unknown
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ connectionId, meterId, proposalId, siteId }) =>
      arcadiaGreenButtonService.selectMeter(
        siteId,
        connectionId,
        meterId,
        proposalId,
      ),
    onSuccess: (_data, { siteId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.arcadiaGreenButton.site(siteId),
      })
    },
  })
}
